import {API_URL_FINTECH} from '../../constants';

export const apiBasePaymentLinkV2 = {
  baseUrl: API_URL_FINTECH,
  endpoints: {
    getLimitFees: '/funding/v1/limits-fees',
    getDefaultPaymentLinkByUserId: (userId: string) =>
      `/funding/v1/public/payment-links/${userId}`,
    getDefaultPaymentLink: '/funding/v1/payment-links/default',
    getPaymentLink: '/funding/v1/payment-links',
    createPaymentSession: '/funding/v1/payment-session',
    submitPaymentSession: (paymentSessionId: string) =>
      `/funding/v1/payment-session/${paymentSessionId}/submit`,
    validateApplePayMerchant: '/funding/v1/apple-pay/merchant/validate',
    submitApplePayPayment: '/funding/v1/apple-pay/pay',
  },
};
